import { useEffect, useRef } from "react";
import { trackSectionView } from "./tracking";

// Fires trackSectionView(sectionName) once, the first time the returned ref
// is ≥50% visible in the viewport. Reused for the FAQ section, reviews
// section, and booking-widget view tracking.
const useSectionView = (sectionName, enabled = true) => {
  const ref = useRef(null);
  const firedRef = useRef(false);

  useEffect(() => {
    if (!enabled || !ref.current || firedRef.current) return undefined;

    const node = ref.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !firedRef.current) {
          firedRef.current = true;
          trackSectionView(sectionName);
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [sectionName, enabled]);

  return ref;
};

export default useSectionView;
